var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-\u5F00\u653E\u5E73\u53F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5BFC\\u822A\\u4F18\\u5316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-265.2583, -40.2583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-\\u5F00\\u653E\\u5E73\\u53F0",
    transform: "translate(264, 39)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(1.2583, 1.2583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    className: "st0",
    d: "M8,1.6c1.6,0,2.8,1.2,2.8,2.7c0,0.8-0.3,1.5-0.9,2L11.5,9c0.1,0,0.3,0,0.5,0 c1.6,0,2.8,1.2,2.8,2.7s-1.3,2.7-2.8,2.7c-1.3,0-2.3-0.8-2.7-1.9H6.8c-0.4,1.1-1.4,1.9-2.7,1.9c-1.6,0-2.8-1.2-2.8-2.7 s1.3-2.7,2.8-2.7c0.1,0,0.3,0,0.4,0l1.6-2.7c-0.5-0.5-0.9-1.2-0.9-2C5.2,2.8,6.4,1.6,8,1.6z M4.1,9.9c-1,0-1.8,0.8-1.8,1.8 s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S5.1,9.9,4.1,9.9z M11.9,9.9c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8 S12.9,9.9,11.9,9.9z M8,7.1c-0.4,0-0.7-0.1-1-0.2L5.5,9.3c0.8,0.4,1.3,1.2,1.4,2.2h2.3c0.1-0.9,0.6-1.7,1.4-2.1L9,6.9 C8.7,7,8.3,7.1,8,7.1z M8,2.6c-1,0-1.8,0.8-1.8,1.8S7,6.1,8,6.1s1.8-0.8,1.8-1.8S9,2.6,8,2.6z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeveloper);
export default __webpack_public_path__ + "static/media/developer.b7c0d46e67a0e75c88fe3d8c1abb8a30.svg";
export { ForwardRef as ReactComponent };